import { ResultCode } from '@/const/ResultCode'
import Vue from 'vue'
import { Toast } from 'vant'
import { mapGetters, mapActions } from 'vuex'
import { judgeDeviceType } from '../../utils'
Vue.use(Toast)
export default {
  // beforeRouteLeave: function (to, from, next) {
  //   if (
  //     from &&
  //     from.meta.index &&
  //     to.meta.index &&
  //     from.meta.index > to.meta.index
  //   ) {
  //     // 如果返回上一层，则摧毁本层缓存。
  //     if (this.$vnode && this.$vnode.data.keepAlive) {
  //       if (
  //         this.$vnode.parent &&
  //         this.$vnode.parent.componentInstance &&
  //         this.$vnode.parent.componentInstance.cache
  //       ) {
  //         if (this.$vnode.componentOptions) {
  //           var key =
  //             this.$vnode.key == null
  //               ? this.$vnode.componentOptions.Ctor.cid +
  //               (this.$vnode.componentOptions.tag
  //                 ? `::${this.$vnode.componentOptions.tag}`
  //                 : '')
  //               : this.$vnode.key
  //           var cache = this.$vnode.parent.componentInstance.cache
  //           var keys = this.$vnode.parent.componentInstance.keys
  //           if (cache[key]) {
  //             if (keys.length) {
  //               var index = keys.indexOf(key)
  //               if (index > -1) {
  //                 keys.splice(index, 1)
  //               }
  //             }
  //             delete cache[key]
  //           }
  //         }
  //   }
  //     }
  //     this.$destroy()
  //   }
  //   next()
  // },
  computed: {
    ...mapGetters(['getLoginStatus', 'getLoadSettingStatus']),
    /**
     * @description 后端没返回图片使用默认图片
     */
    $notImg () {
      return require('~assets/img/ungoodsphoto.png')
    },
    /**
     * @description 供应价小数点位数
     * @author cc
     * @date 2019-11-11
     * @param {price} 供应价
     */
    float_change () {
      return function (price) {
        if (!this.getLoadSettingStatus) return
        if (!isNaN(price * 1)) {
          return (price * 1).toFixed(this.getLoadSettingStatus.data.decimal_point)
        } else {
          return price
        }
      }
    }
  },
  methods: {
    ...mapActions(['LOAD_SETTING_DATA']),
    /**
     * @description 弹出提示
     */
    $tips (result, ...params) {
      const [config = {
        // 是否需要弹出提示
        tip: false,
        duration: 3000
      }] = params
      if (result.status === ResultCode.SUCCESS) {
        if (config.tip) {
          const message = result.info.msg

          Toast({
            message,
            duration: config.duration || message.length < 10 ? 1000 : message.length < 20 ? 2000 : 3000
          })
        }
        const lastParam = arguments[arguments.length - 1]
        if (typeof lastParam === 'function') {
          lastParam.call(this, result.data)
        }
      }
    },
    /**
     * @description 把接口数据整理到data上  需要本地字段跟返回的字段一致
     * @param {data} Object 本地数据结构
     * @param {res} Object  获取的数据
     */
    $mapData (data, res) {
      let options = Object.keys(data)
      for (let prop in data) {
        if (options.includes(prop)) {
          data[prop] = res[prop]
        }
      }
    }
  },
  filters: {
    $getDate (value) {
      if (!value) return ''
      if (value.length === 10) {
        let date = new Date(value * 1000)
        let y = date.getFullYear() + '-'
        let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
        let mm = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
        return y + m + d + h + mm
      }
    }
  },
  directives: {
    /**
     * @description 解决苹果手机input失焦后页面不回滚导致页面卡住
     */
    blurScroll: {
      inserted: function (el) {
        if (!judgeDeviceType.isIOS) { // 不是ios不需要綁定
          return
        }
        /**
         * 如果是直接在'input', 'textarea'使用v-blurScroll,就直接綁定onblur事件
         * 否則查找子代的'input', 'textarea'
         */
        const elArr = ['input', 'textarea']
        if (elArr.includes(el.tagName.toLowerCase())) {
        el.onblur = () => {
          window.scroll(0, 0)
          }
        } else {
          elArr.forEach(item => {
            const els = el.getElementsByTagName(item)
            if (els) {
              [...els].forEach(item => {
                item.onblur = () => {
                  window.scroll(0, 0)
                }
              })
            }
          })
        }
      }
    },
    errorImg: {
      bind (el, binding) {
        let imgURL = binding.value// 获取图片地址
        el.onerror = function () {
          el.setAttribute('src', imgURL)
        }
      }
    },
    focus: {
      inserted: function (el) {
        el.focus()
      }
    },
    deliveryPrice: {
      async bind (el, binding, { context }) {
        if (!context.getLoadSettingStatus?.data) {
          await context.LOAD_SETTING_DATA()
        }
        // eslint-disable-next-line camelcase
        if (context.getLoadSettingStatus?.data?.is_delivery_flag === 1) {
          el.innerHTML = '<span style="font-size: 0.15rem">配送价</span>'
        }
      }
    }
  }
}
